import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { PmiButton } from 'shell/components/shared/button';
import { FiltersFormProvince } from 'system/geographic/pages/province/list/types';
import RegionList from '../region-list';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersProvinceProps {
  filterProvinceForm: FormikProps<FiltersFormProvince>;
}

const FiltersProvince = ({ filterProvinceForm }: FiltersProvinceProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-state-content"
        id="panel-state-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterProvinceForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Sigla provincia"
                label="Sigla provincia"
                id="code"
                name="code"
                fullWidth
                onBlur={filterProvinceForm.handleBlur}
                type="text"
                variant="outlined"
                inputProps={{
                  maxLength: '2',
                }}
                value={filterProvinceForm.values.code}
                onChange={(event) =>
                  filterProvinceForm.setFieldValue(
                    'code',
                    event.target.validity.valid
                      ? event.target.value
                      : filterProvinceForm.values.code
                  )
                }
                error={filterProvinceForm.touched.code && Boolean(filterProvinceForm.errors.code)}
                helperText={filterProvinceForm.errors.code}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <PmiTextField
                aria-label="Nome provincia"
                label="Nome provincia"
                id="name"
                name="name"
                fullWidth
                onBlur={filterProvinceForm.handleBlur}
                type="text"
                inputProps={{
                  maxLength: '24',
                }}
                variant="outlined"
                value={filterProvinceForm.values.name}
                onChange={(event) => {
                  filterProvinceForm.setFieldValue('name', event.target.value);
                }}
                error={filterProvinceForm.touched.name && Boolean(filterProvinceForm.errors.name)}
                helperText={filterProvinceForm.errors.name}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <RegionList
                value={filterProvinceForm.values.region || ''}
                onChange={filterProvinceForm.handleChange}
                onBlur={() => filterProvinceForm.setFieldTouched('region', true)}
                error={
                  filterProvinceForm.touched.region && Boolean(filterProvinceForm.errors.region)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterProvinceForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersProvince.displayName = 'Filters Province component';

export default FiltersProvince;
